export default {
      id: "ic-warning-usage",
      viewBox: "0 0 58 55",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-warning-usage",
      toString: function () {
        return this.url;
      }
    }